export const isMobiUrl = (url: string, currentHostname?: string) => {
  if (url.startsWith('/')) return true

  try {
    const host = normalizeHostname(resolveHostname(currentHostname ?? window.location.hostname))
    const link = new URL(normalizeInputUrl(url))

    return host === normalizeHostname(link.hostname)
  } catch {
    return false
  }
}

const normalizeInputUrl = (value: string) => {
  if (/^https?:\/\//i.test(value)) return value
  return `https://${value}`
}

const resolveHostname = (value: string) => {
  if (/^https?:\/\//i.test(value)) return new URL(value).hostname
  return value
}

const normalizeHostname = (value: string) => value.replace(/^www\./i, '').toLowerCase()
